import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new25",
  "use": "new25-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"new25\"><defs><style>#new25 .cls-1{fill:url(#new25_未命名的渐变_7)}</style><linearGradient id=\"new25_未命名的渐变_7\" x1=\"-248.12\" y1=\"821.7\" x2=\"-248.12\" y2=\"820.7\" gradientTransform=\"matrix(40 0 0 -40 9945 32868)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#ffba97\" /><stop offset=\"1\" stop-color=\"#f5925f\" /></linearGradient></defs><title>椭圆形</title><g id=\"new25_图层_2\" data-name=\"图层 2\"><g id=\"new25_图层_1-2\" data-name=\"图层 1\"><circle id=\"new25_椭圆形\" class=\"cls-1\" cx=\"20\" cy=\"20\" r=\"20\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new25.svg
// module id = gDiG
// module chunks = 6